import React from "react";
import { Snackbar, Alert } from "@mui/material";

const CustomSnackbar = ({ open, message, severity, onClose }) => {
  const getStyles = (severity) => {
    switch (severity) {
      case "success":
        return { bgcolor: "darkgreen", color: "white" };
      case "error":
        return { bgcolor: "red", color: "white" };
      case "message":
        return { bgcolor: "goldenrod", color: "black" };
      default:
        return {};
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Alert
        onClose={onClose}
        severity={severity === "message" ? undefined : severity} // only use built-in severity for success/error
        sx={{
          width: "100%",
          ...getStyles(severity),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
